import { NavLink } from 'react-router';
import { cn } from '@/lib/cn';

const links = [
  { to: '/admin/matches', label: 'Matches' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/settings', label: 'Settings' },
  { to: '/admin/seed', label: 'Seed' },
  { to: '/admin/jobs', label: 'Jobs' },
];

export function AdminNav() {
  return (
    <nav className="flex gap-1 rounded-lg bg-[color:var(--color-bg-elevated)] p-1">
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
              isActive
                ? 'bg-[color:var(--color-accent)] text-white'
                : 'text-[color:var(--color-fg-muted)] hover:text-[color:var(--color-fg)]',
            )
          }
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
